// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AggregateReadResponseEuRange
 */
export interface AggregateReadResponseEuRange {
    /**
     * 
     */
    low?: number;
    /**
     * 
     */
    high?: number;
}

/**
 * Check if a given object implements the AggregateReadResponseEuRange interface.
 */
export function instanceOfAggregateReadResponseEuRange(value: object): value is AggregateReadResponseEuRange {
    return true;
}

export function AggregateReadResponseEuRangeFromJSON(json: any): AggregateReadResponseEuRange {
    return AggregateReadResponseEuRangeFromJSONTyped(json, false);
}

export function AggregateReadResponseEuRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AggregateReadResponseEuRange {
    if (json == null) {
        return json;
    }
    return {
        
        'low': json['low'] == null ? undefined : json['low'],
        'high': json['high'] == null ? undefined : json['high'],
    };
}

export function AggregateReadResponseEuRangeToJSON(json: any): AggregateReadResponseEuRange {
    return AggregateReadResponseEuRangeToJSONTyped(json, false);
}

export function AggregateReadResponseEuRangeToJSONTyped(value?: AggregateReadResponseEuRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'low': value['low'],
        'high': value['high'],
    };
}

